import { render, staticRenderFns } from "./AddAlbumButton.vue?vue&type=template&id=6c2e0eb2&scoped=true"
import script from "./AddAlbumButton.vue?vue&type=script&lang=js"
export * from "./AddAlbumButton.vue?vue&type=script&lang=js"
import style0 from "./AddAlbumButton.vue?vue&type=style&index=0&id=6c2e0eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e0eb2",
  null
  
)

export default component.exports